


































































































































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Consulta } from '../../../../back/src/entity/Consulta';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { Historico } from '../../../../back/src/entity/Historico';
import { HistoricoPergunta } from '../../../../back/src/entity/HistoricoPergunta';
import { HistoricoResposta } from '../../../../back/src/entity/HistoricoResposta';
import { InformacaoParto } from '../../../../back/src/entity/InformacaoParto';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { PlanoDeSaude } from '../../../../back/src/entity/PlanoDeSaude';

import Carregando from '../../components/Carregando.vue';
import ThePacientesResumo from '../../components/pacientes/ThePacientesResumo.vue';
import ThePacientesObservacoesAlert from '../../components/pacientes/ThePacientesObservacoesAlert.vue';
import ThePacientesDadosCadastro from '../../components/pacientes/ThePacientesDadosCadastro.vue';
import ThePacientesDadosFinanceiro from '../../components/pacientes/ThePacientesDadosFinanceiro.vue';
import ThePacientesDadosHistoricos from '../../components/pacientes/ThePacientesDadosHistoricos.vue';
import ThePacientesDadosGestacoes from '../../components/pacientes/ThePacientesDadosGestacoes.vue';
import ThePacientesDadosConsultasNotas from '../../components/pacientes/ThePacientesDadosConsultasNotas.vue';
import ThePacientesDadosExames from '../../components/pacientes/ThePacientesDadosExames.vue';
import ThePacientesDadosVacinas from '../../components/pacientes/ThePacientesDadosVacinas.vue';
import ThePacientesDadosUltrassom from '../../components/pacientes/ThePacientesDadosUltrassom.vue';
import ThePacientesDadosInternacoes from '../../components/pacientes/ThePacientesDadosInternacoes.vue';
import ThePacientesDadosMedicoes from '../../components/pacientes/ThePacientesDadosMedicoes.vue';
import ThePacientesDadosDocumentos from '../../components/pacientes/ThePacientesDadosDocumentos.vue';
import { Internacao } from '../../../../back/src/entity/Internacao';

export default Vue.extend({
  name: 'PacientesVer',
  components: {
    Carregando,
    ThePacientesResumo,
    ThePacientesObservacoesAlert,
    ThePacientesDadosCadastro,
    ThePacientesDadosFinanceiro,
    ThePacientesDadosHistoricos,
    ThePacientesDadosGestacoes,
    ThePacientesDadosConsultasNotas,
    ThePacientesDadosExames,
    ThePacientesDadosVacinas,
    ThePacientesDadosUltrassom,
    ThePacientesDadosInternacoes,
    ThePacientesDadosMedicoes,
    ThePacientesDadosDocumentos,
  },
  data() {
    return {
      loading: {
        paciente: true,
        consultas: true,
        historicosPerguntas: true,
      },
      paciente: null,
      consultas: [] as Consulta[],
      internacoes: [] as Internacao[],
      historicoPerguntas: [] as HistoricoPergunta[],
      tab: 0,
      items: [
        { text: 'Cadastro', entidade: 'Paciente', acao: 'view_cadastro' },
        { text: 'Histórico', entidade: 'Historico', acao: 'view' },
        { text: 'Gestação', entidade: 'Gestacao', acao: 'view' },
        { text: 'Consultas', entidade: 'Consulta', acao: 'view' },
        { text: 'Exames', entidade: 'ResultadoDeExame', acao: 'view' },
        { text: 'Ultrassons/Eco', entidade: 'Ultrassom', acao: 'view' },
        { text: 'Vacinas', entidade: 'Vacinacao', acao: 'view' },
        { text: 'Internações', entidade: 'Internacao', acao: 'view' },
        { text: 'Financeiro', entidade: 'Paciente', acao: 'view_financeiro' },
        { text: 'Documentos', entidade: 'Paciente', acao: 'view_documentos' },
        { text: 'Acompanhamento DG/PA', entidade: 'Paciente', acao: 'view_medicoes' },
      ],
    };
  },
  computed: {
    pacienteId(): number {
      return Number(this.$route.params.pacienteId);
    },
  },
  async mounted() {
    await this.getPaciente();
    await this.getHistoricoPerguntas();
    await this.getConsultas();
    await this.getInternacoes();
    const pacienteAba = this.$store.getters.pacientesAbas(this.paciente.id);
    if (pacienteAba) {
      this.tab = pacienteAba.aba;
    }
  },
  methods: {
    // CARREGANDO DADOS
    async getPaciente() {
      this.loading.paciente = true;
      try {
        const response = await Requester.paciente.paciente(this.pacienteId);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          this.$router.push({ name: 'PacientesIndex' });
        } else {
          this.paciente = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.paciente = false;
      }
    },
    async getConsultas() {
      this.loading.consultas = true;
      try {
        const response = await Requester.paciente.consultas(this.pacienteId);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          this.$router.push({ name: 'PacientesIndex' });
        } else {
          this.consultas = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.consultas = false;
      }
    },
    async getInternacoes() {
      this.loading.internacoes = true;
      try {
        const response = await Requester.paciente.internacoes(this.pacienteId);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          this.$router.push({ name: 'PacientesIndex' });
        } else {
          this.internacoes = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.internacoes = false;
      }
    },
    async getHistoricoPerguntas() {
      this.loadingGetHistoricoPerguntas = true;
      this.historicoPerguntas = [] as HistoricoPergunta[];
      this.loadingGetHistoricoPerguntas = false;
    },
    // ATUALIZANDO DADOS
    // PACIENTE
    atualizaPaciente(paciente: Paciente) {
      this.paciente = paciente;
    },
    atualizaAlturaPaciente(alturaCm: number) {
      this.$set(this.paciente, 'altura_cm', alturaCm);
    },
    // PLANOS DE SAUDE
    atualizaPlanosDeSaude(planosDeSaude: PlanoDeSaude[]) {
      this.paciente.planos_de_saude = planosDeSaude;
    },
    // GESTACAO
    atualizaGestacao(gestacaoAtual: Gestacao): void {
      this.paciente.gestacao_atual = gestacaoAtual;
      const gestacaoIndex = _.findIndex(
        this.paciente.gestacoes as Gestacao[],
        el => el.id === gestacaoAtual.id,
      );
      if (gestacaoIndex < 0) return;
      this.$set(this.paciente.gestacoes, gestacaoIndex, gestacaoAtual);
    },
    atualizaGestacaoFinalizada(gestacao: Gestacao): void {
      const index = _.findIndex(
        this.paciente.gestacoes as Gestacao[],
        el => el.id === gestacao.id,
      );
      if (index < 0) return;
      this.$set(this.paciente.gestacoes, index, gestacao);
    },
    novaGestacao(novaGestacao: Gestacao): void {
      this.paciente.gestacao_atual = novaGestacao;
      this.paciente.gestacoes.push(novaGestacao);
    },
    removeGestacao(gestacao: Gestacao) {
      const index = _.findIndex(this.paciente.gestacoes,
        (item: Gestacao) => item.id === gestacao.id);
      if (index >= 0) this.paciente.gestacoes.splice(index, 1);
    },
    finalizaGestacao(gestacao: Gestacao): void {
      this.atualizaGestacao(gestacao);
      this.$set(this.paciente, 'gestacao_atual', null);
    },
    // CONSULTA
    novaConsulta(novaConsulta: Consulta): void {
      this.consultas.push(novaConsulta);
    },
    cancelaConsulta(consulta: Consulta): void {
      const index = _.findIndex(
        this.consultas as Consulta[],
        el => el.id === consulta.id,
      );
      if (index >= 0) {
        this.$set(this.consultas, index, consulta);
      }
    },
    // HISTORICO
    async atualizaRespostas(respostas: HistoricoResposta[]) {
      _.forEach(respostas, (resposta) => {
        const historicoIndex = _.findIndex(
          this.paciente.historicos as Historico[],
          el => el.id === resposta.historico_id,
        );
        if (historicoIndex < 0) return;
        const respostaIndex = _.findIndex(
          this.paciente.historicos[historicoIndex].historicos_respostas as HistoricoResposta[],
          el => el.id === resposta.id,
        );
        if (respostaIndex < 0) return;
        this.$set(
          this.paciente.historicos[historicoIndex].historicos_respostas,
          respostaIndex,
          resposta,
        );
        this.$store.dispatch('pullHistoricoRespostaFormData', resposta.id);
      });
    },
    async atualizaHistorico(historico: Historico) {
      const historicoIndex = _.findIndex(
        this.paciente.historicos as Historico[],
        el => el.id === historico.id,
      );
      if (historicoIndex < 0) return;
      this.$set(this.paciente.historicos, historicoIndex, historico);
    },
    // INFORMACOES PARTOS
    atualizaInformacaoParto(informacaoParto: InformacaoParto) {
      const index = _.findIndex(
        this.informacoesPartos as InformacaoParto[],
        item => item.id === informacaoParto.id,
      );
      if (index >= 0) {
        this.$set(this.informacoesPartos, index, informacaoParto);
      } else {
        this.informacoesPartos.push(informacaoParto);
      }
    },
  },
  watch: {
    tab() {
      if (this.paciente) {
        this.$store.dispatch('pushPacienteAba', { paciente_id: this.paciente.id, aba: this.tab });
      }
    },
  },
});
